import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyCalnMRlbAGs_nW2lxUhv_KDUBYex3hG6k",
    authDomain: "clone-6cea3.firebaseapp.com",
    databaseURL: "https://clone-6cea3.firebaseio.com",
    projectId: "clone-6cea3",
    storageBucket: "clone-6cea3.appspot.com",
    messagingSenderId: "370562795792",
    appId: "1:370562795792:web:5c8258bcb42a7062ec3d95",
    measurementId: "G-SX0EWVBBH7"
    });

const auth = firebase.auth();

export {  auth };